/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, BigNumberish } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { BoostedSavingsVault } from "../BoostedSavingsVault";

export class BoostedSavingsVault__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _nexus: string,
    _stakingToken: string,
    _boostDirector: string,
    _priceCoeff: BigNumberish,
    _coeff: BigNumberish,
    _rewardsToken: string,
    overrides?: Overrides
  ): Promise<BoostedSavingsVault> {
    return super.deploy(
      _nexus,
      _stakingToken,
      _boostDirector,
      _priceCoeff,
      _coeff,
      _rewardsToken,
      overrides || {}
    ) as Promise<BoostedSavingsVault>;
  }
  getDeployTransaction(
    _nexus: string,
    _stakingToken: string,
    _boostDirector: string,
    _priceCoeff: BigNumberish,
    _coeff: BigNumberish,
    _rewardsToken: string,
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(
      _nexus,
      _stakingToken,
      _boostDirector,
      _priceCoeff,
      _coeff,
      _rewardsToken,
      overrides || {}
    );
  }
  attach(address: string): BoostedSavingsVault {
    return super.attach(address) as BoostedSavingsVault;
  }
  connect(signer: Signer): BoostedSavingsVault__factory {
    return super.connect(signer) as BoostedSavingsVault__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): BoostedSavingsVault {
    return new Contract(address, _abi, signerOrProvider) as BoostedSavingsVault;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_nexus",
        type: "address",
      },
      {
        internalType: "address",
        name: "_stakingToken",
        type: "address",
      },
      {
        internalType: "address",
        name: "_boostDirector",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_priceCoeff",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_coeff",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_rewardsToken",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "Poked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "reward",
        type: "uint256",
      },
    ],
    name: "RewardAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "reward",
        type: "uint256",
      },
    ],
    name: "RewardPaid",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "payer",
        type: "address",
      },
    ],
    name: "Staked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Withdrawn",
    type: "event",
  },
  {
    inputs: [],
    name: "DURATION",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "LOCKUP",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "UNLOCK",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "boostCoeff",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "boostDirector",
    outputs: [
      {
        internalType: "contract IBoostDirector",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "claimReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "claimRewards",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_first",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_last",
        type: "uint256",
      },
    ],
    name: "claimRewards",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "earned",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_first",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_last",
        type: "uint256",
      },
    ],
    name: "exit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "exit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "getBoost",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getRewardToken",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_rewardsDistributor",
        type: "address",
      },
      {
        internalType: "string",
        name: "_nameArg",
        type: "string",
      },
      {
        internalType: "string",
        name: "_symbolArg",
        type: "string",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "lastTimeRewardApplicable",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "lastUpdateTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "nexus",
    outputs: [
      {
        internalType: "contract INexus",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_reward",
        type: "uint256",
      },
    ],
    name: "notifyRewardAmount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "periodFinish",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "pokeBoost",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "priceCoeff",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "rawBalanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "rewardPerToken",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "rewardPerTokenStored",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "rewardRate",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "rewardsDistributor",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "rewardsToken",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_rewardsDistributor",
        type: "address",
      },
    ],
    name: "setRewardsDistribution",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "stake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_beneficiary",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "stake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "stakingToken",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "unclaimedRewards",
    outputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "first",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "last",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "userClaim",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "userData",
    outputs: [
      {
        internalType: "uint128",
        name: "rewardPerTokenPaid",
        type: "uint128",
      },
      {
        internalType: "uint128",
        name: "rewards",
        type: "uint128",
      },
      {
        internalType: "uint64",
        name: "lastAction",
        type: "uint64",
      },
      {
        internalType: "uint64",
        name: "rewardCount",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "userRewards",
    outputs: [
      {
        internalType: "uint64",
        name: "start",
        type: "uint64",
      },
      {
        internalType: "uint64",
        name: "finish",
        type: "uint64",
      },
      {
        internalType: "uint128",
        name: "rate",
        type: "uint128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
